
    import I18n from 'i18nObj';
    
      import 'translations/DeleteGroupView';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('DeleteGroupView');
  